import type { ReactNode } from "react";
import { cn } from "@/shared/lib/cn";
import { Text } from "./Text";

/** A label (+ optional hint) on the left, its control on the right. */
export interface SettingRowProps {
  title: string;
  hint?: string;
  children: ReactNode;
  layout?: "row" | "stacked";
  className?: string;
}

export function SettingRow({ title, hint, children, layout = "row", className }: SettingRowProps) {
  return (
    <div className={cn("flex flex-col items-stretch justify-between gap-2 py-3", layout === "row" && "sm:flex-row sm:items-center sm:gap-4", className)}>
      <div className="flex min-w-0 flex-col gap-0.5">
        <Text variant="ui" as="div">
          {title}
        </Text>
        {hint ? (
          <Text variant="body" className="text-[13px] text-ink-muted">
            {hint}
          </Text>
        ) : null}
      </div>
      <div className={cn("min-w-0", layout === "row" && "sm:shrink-0")}>{children}</div>
    </div>
  );
}
